import gql from 'graphql-tag'

export default gql`
  query AppDetailsQuery($loanId: Int!, $productsCategory: [String!]) {
    products(category: $productsCategory) {
      manualMin
      manualMax
      name
      rid
      lenderKey
      quickDraw
    }
    productSwitchReasons {
      rid
      description
      key
      active
    }
    loan(rid: $loanId) {
      rid
      amount
      hardCreditPulled
      partner {
        selectedProductTypes
      }
      product {
        rid
        name
        manualMin
        manualMax
        lenderKey
      }
    }
  }
`
